Vendd.Scripts.load(function () {
 
    if ($('.x-off-canvas-menu').length <= 0)
        return;

    if (isTouch()) {
        $(window).resize(function () {
            attachToCanvasMenu();
        });
    }

    var isMoved = false;

    if ($(window).width() < 1200) {
        if (isTouch()) {
            if ($('.x-currency-selector').length > 0)
                $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();
            $('.x-call-me-back-widget').detach().prependTo('.js-canvas-menu').show();
            $('.x-shortcut').detach().prependTo('.js-canvas-menu').show();
            $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
            $('.b2b-link-container').detach().appendTo('.js-canvas-menu').show();
            $('.x-wishlist-widget').detach().appendTo('.js-canvas-menu').show();
            var languageSelector = $('.header-region .x-language-selector')
            languageSelector.detach().prependTo('.x-off-canvas-menu .title-container').show();

            if (languageSelector) {
                languageSelector.click(function () {
                    if (!$(languageSelector).hasClass('opened'))
                        $(languageSelector).addClass('opened');
                    else 
                        $(languageSelector).removeClass('opened');
                })
            }
            isMoved = true;
        }
    }

    function attachToCanvasMenu() {

        if ($(window).width() < 1200) {
            if (!isMoved) {
                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();
                $('.x-call-me-back-widget').detach().prependTo('.js-canvas-menu').show();
                $('.x-shortcut').detach().prependTo('.js-canvas-menu').show();
                $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
                $('.b2b-link-container').detach().appendTo('.js-canvas-menu').show();
                $('.header-region .x-language-selector').detach().prependTo('.x-off-canvas-menu .title-container').show();
                $('.x-wishlist-widget').detach().appendTo('.js-canvas-menu').show();

                isMoved = true;
            }
        } else {
            if (isMoved) {
                $('.js-main-menu').detach().insertAfter('.x-sitelogo');
                $('.off-canvas-menu .x-language-selector').detach().insertAfter('.x-menu.main-menu');
                $('.x-shortcut').detach().insertAfter('.x-menu.main-menu');
                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().insertAfter('.x-menu.main-menu');
                $('.x-call-me-back-widget').detach().insertAfter('.x-menu.main-menu');
                $('.x-wishlist-widget').detach().insertAfter('.x-menu.main-menu');

                isMoved = false;
            }
        }
    }

});
